import { render, staticRenderFns } from "./howApply.vue?vue&type=template&id=0567a9ae&scoped=true"
import script from "./howApply.vue?vue&type=script&lang=js"
export * from "./howApply.vue?vue&type=script&lang=js"
import style0 from "./howApply.vue?vue&type=style&index=0&id=0567a9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567a9ae",
  null
  
)

export default component.exports